import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class PayrollFMYExport  {
    _originalTypeClassName = "zERP.BO.PayrollFMYExport";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
PayrollFMYExport.translate = translateService;
}
this.Payrolls = [];
this.Details = [];
this.Id = null;
this.Name = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Name:any;
Payrolls:any;
Details:any;
static setPayrolls = ($this, items) => {
                if (items == null) items = [];
                if ($this.Payrolls == null) $this.Payrolls = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Payrolls.length > 0) {
                    Domain.PayrollFMYExport.removePayrolls($this, $this.Payrolls[0]);
                }

                Domain.PayrollFMYExport.addManyPayrolls($this, copyItems);
            }
static addManyPayrolls = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.PayrollFMYExport.addPayrolls($this, items[i]);
                }
            }
static addPayrolls = ($this, item) => {
                if ($this.Payrolls == null) $this.Payrolls = [];
                if (item == null || $this.Payrolls.indexOf(item) > -1) return;
                $this.Payrolls.push(item);
if (item.FMYExport != $this) {
Domain.Payroll.setFMYExport(item, $this);
}
}
static addRangePayrolls = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.PayrollFMYExport.addPayrolls($this, item));
            }
static removePayrolls = ($this, item) => {
                if ($this == null || $this.Payrolls == null || $this.Payrolls.indexOf(item) === -1) return;
                var _index = $this.Payrolls.indexOf(item);
                $this.Payrolls.splice(_index, 1);
item.FMYExport = null;
}
static clearPayrolls = ($this) => { $this.Payrolls = null; }
static setDetails = ($this, items) => {
                if (items == null) items = [];
                if ($this.Details == null) $this.Details = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Details.length > 0) {
                    Domain.PayrollFMYExport.removeDetails($this, $this.Details[0]);
                }

                Domain.PayrollFMYExport.addManyDetails($this, copyItems);
            }
static addManyDetails = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.PayrollFMYExport.addDetails($this, items[i]);
                }
            }
static addDetails = ($this, item) => {
                if ($this.Details == null) $this.Details = [];
                if (item == null || $this.Details.indexOf(item) > -1) return;
                $this.Details.push(item);
if (item.PayrollFMYExport != $this) {
Domain.PayrollFMYExportDetail.setPayrollFMYExport(item, $this);
}
}
static addRangeDetails = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.PayrollFMYExport.addDetails($this, item));
            }
static removeDetails = ($this, item) => {
                if ($this == null || $this.Details == null || $this.Details.indexOf(item) === -1) return;
                var _index = $this.Details.indexOf(item);
                $this.Details.splice(_index, 1);
item.PayrollFMYExport = null;
}
static clearDetails = ($this) => { $this.Details = null; }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}